import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-center flex-column-fluid p-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "fw-bold mb-10",
  style: {"color":"#a3a3c7"}
}, "Vous êtes deconnecté", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-15" }, "Veuillez fermer votre navigateur.", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}